// src/data/products/spek/tv.tsx

const specifications = {
    tv: {
        specifications: {
          screen: "65 inch",
          resolution: "4K",
          smart: "Smart TV",
          sound: "DIGITAL SURROUND (DTS) 20 W",
        },
        options: {
          screen: [
            { key: "43", value: "43\"" },
            { key: "55", value: "55\"" },
            { key: "65", value: "65\"" },
            { key: "75", value: "75\"" },
            { key: "85", value: "85\"" },
          ],
          resolution: [
            { key: "2k", value: "2K" },
            { key: "4k", value: "4K" },
          ],
          smart: [
            { key: "smart", value: "Smart TV" },
            { key: "touchscreen", value: "Touchscreen" },
          ],
          sound: [
            { key: "stereo", value: "2.0 Channel" },
            { key: "digital", value: "DIGITAL SURROUND (DTS) 20 W" },
          ],
        },
    }
}

export default specifications;